import React, {useState} from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import InfoSection from '../components/InfoSection';
import { homeObjOne } from '../components/InfoSection/Data';
import Aboutjy from '../components/Aboutjy';
import { AboutObjOne } from '../components/Aboutjy/Data'
import Habilities from '../components/Habilities';
import Portafolio from '../components/Portafolio';
import Footer from '../components/Footer';

const Home = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () =>{
        setIsOpen(!isOpen)
    }
    return (
        <>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />
            <InfoSection {...homeObjOne}/>
            <Aboutjy {...AboutObjOne}/>
            <Habilities />
            <Portafolio />
            <Footer />

        </>
    )
}

export default Home
